import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

type PermissionCheckResult =
	| { type: 'auto'; message: string }
	| { type: 'maker-checker'; message: string }
	| { type: 'denied'; message: string };

export function usePermissionCheck(requiredPermission: string, action: string) {
	const { user } = useSelector((state: RootState) => state.auth);
	const [result, setResult] = useState<PermissionCheckResult | null>(null);

	useEffect(() => {
		const check = async () => {
			if (!user) return;

			// Step 1: Collect all permissions across roles
			const rolePermissions: string[] = user.permissions ?? [];

			// Step 2: Check if user already has commit-level permission
			const hasCommit = rolePermissions.includes(action);
			const hasChecker = rolePermissions.includes(requiredPermission);

			if (hasCommit && hasChecker) {
				setResult({ type: 'auto', message: 'Transaction will be committed immediately.' });
			} else if (hasCommit && !hasChecker) {
				setResult({
					type: 'maker-checker',
					message: 'This action requires checker approval before it is committed.',
				});
			} else {
				setResult({
					type: 'denied',
					message: 'You do not have permission to perform this action.',
				});
			}
		};

		check();
	}, [user, requiredPermission, action]);

	return result;
}
